import { render, staticRenderFns } from "./other-setting.vue?vue&type=template&id=1ed864fc&scoped=true&"
import script from "./other-setting.vue?vue&type=script&lang=js&"
export * from "./other-setting.vue?vue&type=script&lang=js&"
import style0 from "./other-setting.vue?vue&type=style&index=0&id=1ed864fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed864fc",
  null
  
)

export default component.exports